import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import type { VenueDTO } from "../../../../common/types/VenueDTO";
import { baseQuery } from "../../client/DefaultClient";

export const venueService = createApi({
  reducerPath: "venueService",
  baseQuery: fetchBaseQuery(baseQuery),
  tagTypes: ["Venue"],
  endpoints: (builder) => ({
    getVenue: builder.query<VenueDTO, { id: number }>({
      query: ({ id }) => `api/identity/venues/${id}`,
      providesTags: (venue) => [{ type: "Venue", id: venue?.id }],
    }),
  }),
});

export const { useGetVenueQuery } = venueService;
